import * as ActionTypes from './OrdersActionTypes';

import * as OrderActionTypes from './view/ActionTypes';
import InitialState from './OrdersInitialState';
import { assign } from '../../shared/Assign';
import {
    IMPERSONATE_SUCCESS,
    UNIMPERSONATE_SUCCESS,
    LOGOUT_SUCCESS
} from '../../actions/actionTypes';
export default function orderReducer(
    state: any = InitialState.orders,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.GET_ORDERS_SUCCESS: {
            const newState = assign({}, state);
            newState.orderCollections = action.result.orderCollections;
            newState.brokerAgents = action.result.brokerAgents;
            return newState;
        }

        case ActionTypes.GET_PLAN_ORDERS_SUCCESS: {
            const newState = assign({}, state);
            newState.list = action.result;
            return newState;
        }

        case ActionTypes.NEW_ORDER_PRODUCTS_SUCCESS: {
            const newState = assign({}, state);
            newState.create.newOrder.availableProducts = action.result;
            return newState;
        }

        case ActionTypes.NEW_ORDER_SUCCESS: {
            const newState = assign({}, state);
            newState.create.newOrder = action.result;
            return newState;
        }

        case ActionTypes.GET_AGREEMENT_SUCCESS: {
            const newState = assign({}, state);
            newState.create.agreement = action.result;
            return newState;
        }

        case ActionTypes.GET_PHOTO_ORDERS_SUCCESS: {
            const newState = assign({}, state);
            newState.photoOrders.list = action.result.photoOrders;
            newState.photoOrders.regions = action.result.regions;
            newState.photoOrders.imageEditorFirms = action.result.imageEditorFirms;
            newState.photoOrders.orderStatuses = action.result.orderStatuses;
            newState.photoOrders.deliveredStatuses = action.result.deliveredStatuses;
            return newState;
        }

        case ActionTypes.GET_UNBOOKED_ORDERS_SUCCESS: {
            const newState = assign({}, state);
            newState.photoOrders.list = action.result.unBookedOrders;
            newState.photoOrders.regions = action.result.regions;
            return newState;
        }

        case ActionTypes.GET_FILM_ORDERS_SUCCESS: {
            const newState = assign({}, state);
            newState.filmOrders.list = action.result.filmOrders;
            newState.filmOrders.orderStatuses = action.result.orderStatuses;
            newState.filmOrders.regions = action.result.regions;
            return newState;
        }

        case ActionTypes.GET_ADVANCE_SEARCH_FILTERS_SUCCESS: {
            const newState = assign({}, state);
            newState.advanceList.filters = action.result;
            return newState;
        }

        case ActionTypes.GET_ADVANCE_SEARCH_ORDERS_SUCCESS: {
            const newState = assign({}, state);
            newState.advanceList.result = action.result;
            return newState;
        }

        case ActionTypes.SAVE_ADVANCE_SEARCH_FILTER_SUCCESS: {
            const newState = assign({}, state);
            newState.filters.advanceListFilter = action.result;
            return newState;
        }

        case ActionTypes.SAVE_AGENT_BROKER_FILTERS_SUCCESS: {
            const newState = assign({}, state);
            newState.filters.agentBrokerFilters = action.result;
            return newState;
        }
        
        case IMPERSONATE_SUCCESS:
        case UNIMPERSONATE_SUCCESS:
        case LOGOUT_SUCCESS: {
            let filters = assign({}, state.filters);
            const newState = assign({}, InitialState.orders);
            newState.filters = filters;
            return newState;
        }

        case ActionTypes.CHECK_IF_ORDER_IS_ARCHIVED_SUCCESS: {
            const newState = assign({}, state);
            newState.photoIsArchived = action.result.photoIsArchived;
            newState.photoIsPreArchived = action.result.photoIsPreArchived;
            newState.planIsArchived = action.result.planIsArchived;
            newState.planIsPreArchived = action.result.planIsPreArchived;
            newState.archivedStatus = action.result.archivedStatus;

            return newState;
        }

        case ActionTypes.SAVE_ORDER_COMMAND_FOR_BOOKING_SUCCESS: {
            const newState = assign({}, state);
            newState.orderCommandForBooking = action.result;
            return newState;
        }

        case ActionTypes.REMOVE_ORDER_COMMAND_FOR_BOOKING_SUCCESS: {
            const newState = assign({}, state);
            newState.orderCommandForBooking = null;
            return newState;
        }

        case OrderActionTypes.ASSIGN_USER_ORDER_SUCCESS: {
            const newState = assign({}, state);
            if (newState.list) {
                newState.list.forEach((x) => {
                    if (x.id === action.result.orderId) {
                        x.assignedUserName = action.result.assignedUserName;
                    }
                });
            }

            if (newState.photoOrders && newState.photoOrders.list) {
                newState.photoOrders.list.forEach((x) => {
                    if (x.orderId === action.result.orderId) {
                        x.assignedUserName = action.result.assignedUserName;
                    }
                });
            }

            return newState;
        }

        default:
            return state;
    }
}
